/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import {
  COLLAPSE_CAPACITY_BETA,
  COLLAPSE_CAPACITY_MEDIAN,
  COLLAPSE_DEFINITION_METHOD,
  FEMA_154_SCORE,
  FEMA_154_SCORE_CALCULATION_METHOD,
  INCLUDE_COLLAPSE,
  PROB_COLLAPSE_MCE,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { COLLAPSE_METHOD_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import { modelTypesByForm, MODEL_TYPE_2_ID } from '#src/js/constants/models/modelTypes/index.js';
import {
  selectRunOutputProbCollapseMce,
  selectRunOutputCollapseCapacityMedian,
} from '#selectors/entities/models.js';
import BuildingStabilityView from './BuildingStabilityView.jsx';

const { COLLAPSE_METHOD_FEMA, COLLAPSE_METHOD_MCE, COLLAPSE_METHOD_MEDIAN } =
  COLLAPSE_METHOD_VALUES;

const mapStateToProps = (state, ownProps) => {
  const { modelId, form, modelType } = ownProps;
  const { selectFormFieldVisibility, selectFormValues, selectIsCountryJapan } =
    modelTypesByForm[form];

  const collapseDefinitionMethod = selectFormValues(state, COLLAPSE_DEFINITION_METHOD);
  const showMessage = !selectFormValues(state, INCLUDE_COLLAPSE);
  const isJapan = selectIsCountryJapan(state);
  const showFema154Score = selectFormFieldVisibility(state)(FEMA_154_SCORE);
  const showFema154ScoreCalculationMethod = selectFormFieldVisibility(state)(
    FEMA_154_SCORE_CALCULATION_METHOD
  );
  const showProbCollapseMce = selectFormFieldVisibility(state)(PROB_COLLAPSE_MCE);
  const showCollapseMedian = selectFormFieldVisibility(state)(COLLAPSE_CAPACITY_MEDIAN);
  const showCollapseBeta = selectFormFieldVisibility(state)(COLLAPSE_CAPACITY_BETA);

  const probCollapseMce = selectRunOutputProbCollapseMce(state, { modelId });
  const collapseCapacityMedian = selectRunOutputCollapseCapacityMedian(state, { modelId });

  const showProbCollapseMceRO =
    !isJapan &&
    modelType === MODEL_TYPE_2_ID &&
    [COLLAPSE_METHOD_FEMA, COLLAPSE_METHOD_MEDIAN].includes(collapseDefinitionMethod);

  const showCollapseMedianRO =
    !isJapan &&
    modelType === MODEL_TYPE_2_ID &&
    [COLLAPSE_METHOD_FEMA, COLLAPSE_METHOD_MCE].includes(collapseDefinitionMethod);

  return {
    showFema154Score,
    showFema154ScoreCalculationMethod,
    showProbCollapseMce,
    showProbCollapseMceRO,
    showCollapseMedian,
    showCollapseMedianRO,
    probCollapseMce,
    collapseCapacityMedian,
    showCollapseBeta,
    showMessage,
  };
};
export default connect(mapStateToProps)(BuildingStabilityView);
